export default __webpack_public_path__ + "static/app_scrnshot_1-39f8bbcd05653b107fd71b637436908b.png";